import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
  createGeoPointFromString,
  geoPointInputTransform,
  geoPointPasteEventHandler,
  geoPointValueBlur,
  geoPointValueChange,
} from '@blaze-shared/shared-feature';
import { GeoPoint } from '@blaze-shared/shared-util';

import { type InlineEditorConfig } from '../base-editor/inline-editor.types';

@UntilDestroy()
@Component({
  selector: 'be-geo-point-editor',
  templateUrl: './geo-point-editor.component.html',
  styleUrls: ['./geo-point-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableGeoPointEditorComponent implements AfterViewInit {
  valueChange = output<GeoPoint | null>();

  @Input() config?: InlineEditorConfig;

  @ViewChild('stringInput') stringInput!: ElementRef<HTMLInputElement>;

  geoPointFormControl = new UntypedFormControl('');
  geoPointInputTransformFn = geoPointValueChange;
  geoPointPasteFn = geoPointPasteEventHandler;
  geoPointValueBlurFn = geoPointValueBlur;

  @Input() set value(val: string | number | undefined) {
    this.geoPointFormControl.patchValue(geoPointInputTransform(val));
  }

  constructor() {
    this.geoPointFormControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.emitValue(createGeoPointFromString(value));
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.stringInput.nativeElement.focus();
      this.stringInput.nativeElement.select();
    });
  }

  private emitValue(value: GeoPoint | null): void {
    this.valueChange.emit(value);
  }
}
